import { PAGE_SOURCE } from "../../../constants/app-constants";

const valuationPageStyles = () => {
    const wrapperStyle = "styles.wrapperValuation";
    const textStyle = "styles.textValuation";
    const contentWrapStyle = "styles.contentWrapValuation";
    const outerStyle = "styles.outerValuation";
    return {
        wrapperStyle,
        textStyle,
        contentWrapStyle,
        outerStyle
    };
};

const sellPageStyles = () => {
    const wrapperStyle = "styles.wrapper";
    const textStyle = "styles.text";
    const contentWrapStyle = "styles.contentWrap";
    const outerStyle = "styles.outer";
    return {
        wrapperStyle,
        textStyle,
        contentWrapStyle,
        outerStyle
    };
};
const detailsPageStyles = () => {
    const wrapperStyle = "styles.wrapperDetails";
    const textStyle = "styles.textDetails";
    const contentWrapStyle = "styles.contentWrapDetails";
    const outerStyle = "styles.outerDetails";
    return {
        wrapperStyle,
        textStyle,
        contentWrapStyle,
        outerStyle
    };
};
const defaultStyles = () => {
    const wrapperStyle = "styles.defaultWrapper";
    const textStyle = "styles.defaultText";
    const contentWrapStyle = "styles.defaultContentWrap";
    const outerStyle = "styles.defaultOuter";
    return {
        wrapperStyle,
        textStyle,
        contentWrapStyle,
        outerStyle
    };
};

export const getStyles = (source) => {
    if (source === PAGE_SOURCE.SELL_PAGE) {
        return sellPageStyles();
    } else if (source === PAGE_SOURCE.SELL_VALUATION_PAGE) {
        return valuationPageStyles();
    } else if (source === PAGE_SOURCE.CDP) {
        return detailsPageStyles();
    }
    return defaultStyles();
};
